// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-size[data-v-c763d446]{max-height:46px}.icon-button[data-v-c763d446]{position:absolute;top:50%;transform:translateY(-50%);right:1.25rem}.bottom-arrow[data-v-c763d446]{position:relative}.bottom-arrow[data-v-c763d446]:after{position:absolute;content:\"\";width:0;height:0;bottom:-22px;left:50%;border:12px solid transparent;border-top:14px solid #e6e6e6;transform:translate(-50%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
